
//Экшны для интерфейса
/**указатель размера палитры */
export const setPaletteWidth = (width) => {
  //palette
  return {type: 'SET_UI_PALETTE_WIDTH', payload:width};
};
/**полученный из браузера реальный размер выбиралки диапазона дат */
export const setRangerHeight = (rangerHeight) => {
  //palette
  return {type: 'SET_UI_RANGER_HEIGHT', payload:rangerHeight};
};
/**Выбраный гео-объект (одиночный режим) */
export const setSelectedGeoObj = (selectedGeoObj) => {
  //palette
  return {type: 'SET_UI_GEO_OBJ', payload:selectedGeoObj};
};
/**Массив выбранных гео-объектов */
export const setSelectedGeoObjArray = (selectedGeoObjArray) => {
  return {type: 'SET_UI_GEO_OBJ_ARR', payload:selectedGeoObjArray};
};
/**Критерий отбора данных ("1" - трекеры, "2" - геозоны ) */
export const setGeoObjCriteria = (geoObjCriteria) => {
  return {type: 'SET_UI_GEO_OBJ_CRITERIA', payload:geoObjCriteria};
};
/**Критерий отбора данных ('today','week',period') , см ../const */
export const setDateRangeCriteria = (dateRangeCriteria) => {
  return {type: 'SET_UI_DATE_RANGE_CRITERIA', payload:dateRangeCriteria};
};
/**Начало диапазона дат */
export const setRangeStartDate = (rangeStartDate) => {
  console.log('32 rangeStartDate', rangeStartDate)
  return {type: 'SET_UI_RANGE_START_DATE', payload:rangeStartDate};
};
/**Конец диапазона дат */
export const setRangeEndDate = (rangeEndDate) => {
  console.log('32 rangeEndDate', rangeEndDate)
  return {type: 'SET_UI_RANGE_END_DATE', payload:rangeEndDate};
};

/**Отрытие/закрытие DRAWER компонента*/
export const setDrawerOpen = (isDrawerOpen) => {
  return {type: 'SET_UI_DRAWER_OPEN', payload: isDrawerOpen};
};

/**Отрытие/закрытие BLOCK_LEFT_MENU в мобильной верстке*/
export const setBlockLeftMenuMobileOpen = (isLeftMenuMobileOpen) => {
  return {type: 'SET_UI_MOBILE_BLOCK_LEFT_MENU_OPEN', payload: isLeftMenuMobileOpen};
};

/** Показать/скрыть тултипы в маршрутах трэкера **/
export const setShowRouteTooltips = (isShowRouteTooltips) => {
  return {type: 'SET_UI_SHOW_ROUTE_TOOLTIPS', payload: isShowRouteTooltips};
};

/** Показать/скрыть мобильные меню/бургеры (моб адаптация) **/
export const setShowBurgerMenu = (burgerMenu) => {
  return {type: 'SET_UI_SHOW_MOBILE_MENUS', payload: burgerMenu};
};
